import { Typography } from "@mui/material";
import React from "react";
import ExpenseReportItem from "./ExpenseReportItem/ExpenseReportItem";
import { Props } from "./interfaces";
import { ExpenseReportsContainer, NoItemsContainer } from "./styles";
import AddEditExpenseReport from "../AddEditExpenseReport/AddEditExpenseReport";

const ExpenseReportTable = ({
  items,
  view,
  handleNotifyParent,
  parentIsLoading,
  forExport = false,
  employee,
  readOnly = false,
  wholeReportIsReadOnly = false,
  preloadedFlags,
}: Props) => {
  return (
    <>
      {!!items.length && (
        <ExpenseReportsContainer forExport={forExport}>
          {items.map((item) => {
            return (
              <AddEditExpenseReport
                key={item.id}
                effect={"edit"}
                handleNotifyParent={handleNotifyParent}
                item={item}
                view={view}
                employee={employee ?? item?.employee}
                readOnly={readOnly}
                wholeReportIsReadOnly={wholeReportIsReadOnly}
                parentIsLoading={parentIsLoading}
              >
                <ExpenseReportItem
                  expenseReport={item}
                  view={view}
                  handleNotifyParent={handleNotifyParent}
                  readOnly={readOnly || wholeReportIsReadOnly}
                  preloadedFlags={preloadedFlags}
                />
              </AddEditExpenseReport>
            );
          })}
        </ExpenseReportsContainer>
      )}

      {!items.length && !parentIsLoading && (
        <NoItemsContainer>
          <Typography>No items</Typography>
        </NoItemsContainer>
      )}
    </>
  );
};

export default ExpenseReportTable;
